import Link from 'next/link';
import classNames from 'classnames';
import { IMenuItem } from 'src/lib/types/Settings';
import styles from './Hotlinks.module.css';

//#region [Styles]
// Converted to CSS Modules (Hotlinks.module.css) preserving SHotlink class.
//#endregion

//#region [Props]
type HotlinksProps = {
	hotlinks?: IMenuItem[];
};
//#endregion

//#region [Component]
export default function Hotlinks({ hotlinks }: HotlinksProps) {
	if ((hotlinks?.length ?? 0) === 0) {
		return null;
	}

	return <>
		{hotlinks!.map(hl => {
			const url = hl.url;
			const linktext = hl.text;
			let isEaster = false;
			if (linktext.toLocaleLowerCase().includes("påske")) isEaster = true;
			return (<div key={hl._key} className={classNames(styles.SHotlink, {
				[styles.easter]: isEaster
			})}><Link href={url}>{linktext}</Link></div>);
		})}
	</>;
}
//#endregion
